export enum NODE_ENV {
  PRODUCTION = 'production',
  DEVELOPMENT = 'development',
  TEST = 'test',
}

export enum PLATFORM_ENV {
  PRODUCTION = 'production',
  PRODUCTION_MIRROR_1 = 'p-m1',
  STAGING = 'staging',
  STAGING_MIRROR_1 = 's-m1',
  DEVELOPMENT = 'dev',
  TEST = 'test',
  SANDBOX = 'sandbox',
  RELEASE = 'release',
  ENTERPRISE = 'enterprise',
}
